import { TiDelete } from "react-icons/ti";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import ImageSelector from "./ImageSelector";
import styles from './PageEdit.module.css';

export default function ImageSliderSelectorItem({ id, image, onChange, onRemove }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={{ ...style, position: 'relative', paddingTop: '30px' }} className={styles.item}>
      {/* Drag handle — keeps drag listeners off the image picker & delete icon */}
      <div {...attributes} {...listeners} style={{ cursor: 'grab', padding: '4px', userSelect: 'none' }}>
        ⠿
      </div>

      <ImageSelector value={image} updateField={onChange} />

      <TiDelete
        onClick={onRemove}
        style={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer' }}
        className={`${styles.iconBnt} ${styles.deleteIcon}`}
      />
    </div>
  );
}